import { OpenAPI } from '@/services/api';

OpenAPI.WITH_CREDENTIALS = true;
OpenAPI.BASE = import.meta.env.VITE_API_URL || '';
